import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Trash2 } from 'feather-icons-react/build/IconComponents';
import CustomPropTypes from 'CustomPropTypes';
import { Link } from 'react-router-dom';
import { Button, ButtonGroup } from 'react-bootstrap';

const initData = {
  id: 0,
  shipId: 0,
  partnumber: '',
  serialNumber: '',
  boxQty: '',
  qtyperBox: '',
  userName: '',
};

const PickTicketTable = ({ data, onChanges }) => {
  const [partInputs, setPickTicketInputs] = useState(initData);

  const [pickTickets, setPickTickets] = useState(data || []);

  useEffect(() => {
    if (onChanges) onChanges(pickTickets);
  }, [pickTickets, onChanges]);

  useEffect(() => {
    setPickTickets(data || []);
  }, [data]);

  return (
    <div className="row border">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header">
            <h5 className="card-title">Pick Ticket</h5>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead>
                  
                  <tr>
                    <th>Serial Number</th>
                    <th>Part Number</th>
                    <th>Number of Boxes</th>
                    <th>Qty Per Box</th>
                    <th>Scanned User</th>
                  </tr>
                </thead>
                <tbody>
                  {pickTickets.map(pickTicket => (
                    <tr key={pickTicket.id}>
                      <td>{pickTicket.serialNumber}</td>
                      <td>{pickTicket.partNumber}</td>
                      <td>{pickTicket.boxQty}</td>
                      <td>{pickTicket.qtyperBox}</td>
                      <td>{pickTicket.userName}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
PickTicketTable.defaultProps = {
  onChanges: () => {},
};

PickTicketTable.propTypes = {
  onChanges: PropTypes.func,
  data: CustomPropTypes.Parts,
};

export default PickTicketTable;
